import React, { useState, useEffect, useRef } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, FormGroup, Box, Typography, ListItemText, Autocomplete, Chip ,CircularProgress} from '@mui/material';
import { Link } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { styled } from '@mui/material/styles';
import Grid from '@mui/system/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import axios from 'axios';
import { toast } from 'react-toastify';

const CreateDriverForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    email: '',  
    oldPassword: '',  
    newPassword: '',  
    confirmPassword: '',  
    phone: '',  
    address: '',  
    latitude: '',  
    longitude: '',  
  });
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem('authToken');  
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/admin/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200) {
          const data = response.data?.user;
          setFormData({
            name: data.fullName || '',  
            description: data.description || '',  
            email: data.email || '',
            phone: data.phone || '',  
            address: data.address || '',  
            latitude: data.latitude || '',  
            longitude: data.longitude || '',  
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
          });
        }
      } catch (error) {
        toast.error('Failed to fetch user data');
        console.error('Error fetching user data:', error);
      }
    };
  
    fetchUserData();
  }, []); 

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const formDataToSend = new FormData();
    formDataToSend.append('fullName', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('oldPassword', formData.oldPassword);
    formDataToSend.append('newPassword', formData.newPassword);
    formDataToSend.append('confirmPassword', formData.confirmPassword);
    formDataToSend.append('vendorDetails[phone]', formData.phone);
    formDataToSend.append('vendorDetails[address]', formData.address);
    formDataToSend.append('vendorDetails[latitude]', formData.latitude);
    formDataToSend.append('vendorDetails[longitude]', formData.longitude);
    formDataToSend.append('vendorDetails[description]', formData.description);
    if (formData.image) {
      formDataToSend.append('image', formData.image); 
    }
  
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/user/admin/update`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
      });
  
      if (response.status === 200) {
        toast.success(`${response.data.message}`);
        setFormData({
          name: '',
          description: '',
          email: '',
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
          phone: '',
          address: '',
          latitude: '',
          longitude: '',
        });
      }
    } catch (error) {
      toast.error('User is not updated');
      console.error('Error creating item:', error);
    }finally {
      setLoading(false);
    }
  };
  

  return (
    <Box sx={{ maxWidth:{xs:"100%",md:'70%'}, margin:{xs:"0",md:'auto'}, padding:{xs:0,md:2}}}>
      <form onSubmit={handleSubmit}>
        <fieldset
          style={{
            border: '1px solid #ccc',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
          }}
        >
          <legend
            style={{
              padding: '8px',
              width: 'auto',
              background: '#3C7F10',
              color: '#fff',
              borderRadius: '8px',
            }}
          >
            Driver Details
          </legend>
          <Box className='input-field-cls' sx={{ flexGrow: 1 }}>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Name
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  helperText="Insert name"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Email
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="email"
                  type="email" // Set the input type to email for validation
                  value={formData.email}
                  onChange={handleChange}
                  helperText="Enter your email address"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Old Password
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="oldPassword"
                  type="password" // Set the input type to password to mask input
                  value={formData.oldPassword}
                  onChange={handleChange}
                  helperText="Enter your old password"
                />
              </Grid>
            </Grid>
          </Box>


        </fieldset>
        <fieldset
          style={{
            border: '1px solid #ccc',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
          }}
        >
          <legend
            style={{
              padding: '8px',
              width: 'auto',
              background: '#3C7F10',
              color: '#fff',
              borderRadius: '8px',
            }}
          >
            Vendor Details
          </legend>
          <Box className="input-field-cls" sx={{ flexGrow: 1 }}>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
              {/* Existing fields */}
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Phone Number*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="phone"
                  type="tel"  // Phone input type for validation
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  helperText="Enter your phone number"
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Address*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  helperText="Enter your address"
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Latitude*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="latitude"
                  type="number"  // Numeric input type
                  value={formData.latitude}
                  onChange={handleChange}
                  required
                  helperText="Enter the latitude"
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Longitude*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="longitude"
                  type="number"  // Numeric input type
                  value={formData.longitude}
                  onChange={handleChange}
                  required
                  helperText="Enter the longitude"
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 12 }}>
                <Box sx={{ marginBottom: 2, maxWidth: { xs: "250px", md: "100%" }, width: { xs: "100%" } }}>
                  <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                    Image*
                  </Typography>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ marginBottom: '10px' }}
                    ref={fileInputRef} // Attach the ref to the file input
                  />
                  {/* {formData.image && <Typography variant="body2">{formData.image.name}</Typography>} */}
                  <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                    Insert image in jpg/png format
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 12 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Description*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  required
                  multiline
                  rows={6}  // Multiline text for description
                  helperText="Provide a description"
                />
              </Grid>


            </Grid>
          </Box>
        </fieldset>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button variant="contained" sx={{ bgcolor: 'green', color: '#fff' }} type="submit">
          {loading ? (
     <CircularProgress sx={{color:'#fff'}} size="20px" />  // Show loader inside the button
    ) : (
      <SaveIcon  />
    )}
     <Typography variant="body2" gutterBottom sx={{ pl: 1 ,m:0}}>
       Save
      </Typography>
          </Button>
          <Link to="/drivers" style={{ textDecoration: 'none' }}>
            <Button variant="contained" sx={{ bgcolor: 'transparent', color: 'green', boxShadow: 'unset' }}>
              <SettingsBackupRestoreIcon sx={{ pr: 1 }} />
              Back
            </Button>
          </Link>
        </Box>
      </form>
    </Box>
  );
};

export default CreateDriverForm;